import React from 'react';
import App from "./components/App";
import ReactDOM from 'react-dom';

ReactDOM.render(<App/>,document.getElementById('root'));

